/*
 * @Description:
 * @Author: kangkang
 * @Date: 2022-06-23 23:24:12
 * @LastEditTime: 2024-05-12 16:17:46
 * @LastEditors: kangkang
 * @Reference:
 */
/**
 * api 接口
 * @author: kinds
 * @create: 2017-11-20 14:35
 */
import Vue from "vue";
import axios from "axios";
import router from "../router";
import moment from 'moment';
import Store from '../store';
// toast
import { Toast } from 'vant';

Vue.use(Toast);
const _domain = process.env.VUE_APP_API_URL;

// 创建axios实例
const axiosInstance = axios.create({
    baseURL: _domain, //url
    headers: {
        //将被发送的自定义请求头
        // "Content-Type": "application/x-www-form-urlencoded"
    },
    withCredentials: true, //表示跨域请求时是否需要使用凭证
    timeout: 10000 //请求超时的毫秒数
});

// 添加请求拦截器
axiosInstance.interceptors.request.use(
    function(config) {
        // 在发送请求之前做些什么
        let _token = sessionStorage.access_token;
        if(_token){
            if(sessionStorage.requestTime){
                let storageTime = sessionStorage.requestTime;
                let date = parseInt(moment(new Date()).valueOf() / 1000);
                let expiresIn = sessionStorage.expires_in;//规定token 过期时间
                let diff = date - storageTime * 1;//相差秒数
                if(expiresIn * 1 - diff < 1800){
                    Store.dispatch("doGetRefreshToken")
                }
            }
            if(config.url.indexOf('refreshToken') != -1){
                config.headers['authorization'] = 'Bearer '+ sessionStorage.refresh_token
            }else{
                config.headers['authorization'] = 'Bearer '+_token
            }

        }
        return config;
    },
    function(error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 添加响应拦截器
axiosInstance.interceptors.response.use(
    function(response) {
        // 对响应数据做点什么
        if (response.data.apiResultCode == 200) {
            return response.data.apiResultData;
        }
        else {
            Toast(response.data.apiErrorMsg);
            return Promise.reject(response.data);
        }
    },
    function(error) {
        // 对响应错误做点什么
        return Promise.reject(error);
    }
);

export default axiosInstance;
export const domain = _domain;
